import { render, staticRenderFns } from "./Delegacao.vue?vue&type=template&id=5d1b7af6&"
import script from "./Delegacao.vue?vue&type=script&lang=js&"
export * from "./Delegacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports